import { useQuery } from "@tanstack/react-query";
import { api } from "@/api/client";
import { queryKeys } from "@/lib/queryKeys";

export interface AdoptionQuality {
  first_pass_gate_success_rate: number | null;
  sample_size: number;
  acceptance_rate: number | null;
  hitl_sample_size: number;
}

export interface AdoptionData {
  total_members: number;
  active_members: number;
  period_days: number;
  quality: AdoptionQuality;
}

export function useAdoption(projectSlug?: string) {
  // Failures are swallowed on purpose (pre-existing behavior): adoption is
  // a decorative widget, never surfaces an error to the caller.
  const query = useQuery({
    queryKey: queryKeys.metrics.adoption(projectSlug ?? "org"),
    queryFn: async () => {
      try {
        const params = new URLSearchParams();
        if (projectSlug) {
          params.set("project_id", projectSlug);
        }
        const qs = params.toString();
        return await api<AdoptionData>(`/api/v2/adoption${qs ? `?${qs}` : ""}`);
      } catch {
        return null;
      }
    },
  });

  return { data: query.data ?? null, loading: query.isLoading };
}
